import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetSpecialty,
	adminGetAllSpecialties,
	resetFocusSpecialty,
    initNewSpecialty,
    adminPatchSpecialty,
	adminPostSpecialty,
	adminDeleteSpecialty
} from 'services/specialty';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/Specialties/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis')
});

class SpecialtiesAdmin extends Component {
	

	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusSpecialty();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllSpecialties();
	};

	focusOnElement = elt => {
		this.props.adminGetSpecialty(elt);
	};

	onAddClick = () => {
		this.props.initNewSpecialty();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostSpecialty(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchSpecialty(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteSpecialty(this.props.specialties.focus.data);
	};

	render() {
		const { specialties } = this.props;
		const { focus, list } = specialties;
		const specialty = focus.data;
		const newSpecialty = specialty !== null && specialty.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={specialties.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='SPÉCIALITÉS'
					addButtonText='Nouvelle spécialité'
					onAddButtonClick={this.onAddClick}
					defaultLabel={e => e.name}
					groupField={false}
					focusedEltId={specialty}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Spécialités'
					icon='info'
				>
					{specialty !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: specialty.id,
								name: specialty.name || ''
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusSpecialty}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newSpecialty ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newSpecialty && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={e => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex'
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0'
	}
};

const mapStateToProps = state => {
	return {
		specialties: state.admin.specialties
	};
};

const mapDispatchToProps = {
	adminGetAllSpecialties,
	adminGetSpecialty,
	adminPatchSpecialty,
	adminDeleteSpecialty,
	resetFocusSpecialty,
	adminPostSpecialty,
	initNewSpecialty
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecialtiesAdmin);
